import { gql } from 'apollo-boost';

export const ALL_DEVICES = gql`
  query ($limit: Int, $offset: Int, $search: String, $sortBy: String, $direction: String, $onlyUnassigned: Boolean) {
      hubs (limit: $limit, offset: $offset, search: $search, sortBy: $sortBy, direction: $direction, onlyUnassigned: $onlyUnassigned) {
        list {
          id,
          description,
          serial_number,
          adc_customer_id,
          imei,
          builder_id,
          property_id,
          comments,
          delay_animation,
          created_on,
          created_by,
          modified_on,
          modified_by,
          hub_type,
          adc_disarm_unlock_enabled,
          hub_account_id,
          hub_account {
            username,
          },
          builder {
            name,
          }
        }
        params {
          total
          limit
          offset
        }
      }
  }
`;
export const UPDATE_DEVICE = gql`
mutation updateHub($device: inputHub!) {
  updateHub(hub: $device) {
    id
  }
}
`;

export const UPDATE_ADC_DISARM_UNLOCK = gql`
  mutation updateAdcDisarmUnlock($id: String!, $enabled: Boolean!) {
    updateAdcDisarmUnlock(id: $id, enabled: $enabled) {
      id
      adc_disarm_unlock_enabled
    }
  }
`;

export const DEVICE_BY_ID = gql`
  query ($serial_number: String!){
    getHubById(serial_number: $serial_number) {
        id,
        description,
        serial_number,
        adc_customer_id,
        imei,
        property_id,
        hub_type,
        hub_account_id,
        builder_id,
        comments,
        adc_device_id,
        delay_animation,
        logs {
          id,
          serial_number,
          action,
          hub_type,
          lock_type,
          property_id,
          created_on,
          created_by,
          created_by_email,
        }
  }
  }
`;

export const DELETE_HUBS = gql`
  mutation ($ids: [String!]!){
    deleteMultipleHubs(ids: $ids)
}
`;

export const UPDATE_DEVICES = gql`
  mutation updateMultipleHubs($devices: [inputHub!]!) {
    updateMultipleHubs(hubs: $devices) {
      id
    }
  }
`;

export const GET_HUBACCOUNT_IDS = gql`
  query {
    hubAccountIds {
      id
      username
    }
  }
`;

export const DISARM_ADC_ALARM = gql`
  query ($serialNumber: String!) {
    disarmADCAlarm(serialNumber: $serialNumber)
  }
`;

export const GET_ADC_ALARM_STATUS = gql`
  query ($serialNumber: String!) {
    getAdcAlarmStatus(serialNumber: $serialNumber) {
      hardwareStatuses {
        deviceId
        deviceName
        deviceType
        category
        status
        label
        variant
        statusCodes
      }
      deviceStatus {
        status
        label
        variant
      }
      lockStatus {
        status
        label
        variant
      }
    }
  }
`;
